import { Pipe, PipeTransform } from '@angular/core';
import { IngredientChoice } from 'ngx-web-api';

@Pipe({
  name: 'choiceGroupFilter',
})
export class ChoiceGroupFilterPipe implements PipeTransform {
  transform(choices: IngredientChoice[], grouppedChoiceNames?: string[]): IngredientChoice[] {
    if (grouppedChoiceNames && grouppedChoiceNames.length) {
      return choices.filter(choice => grouppedChoiceNames.some(chName => chName === choice.name));
    }

    return choices;
  }
}
